import Color from "color";
import {CommunicationColors, SharedColors} from "@fluentui/theme";
import {ReplyState} from "./../components/SupportEditTicketMessages";
import {SupportTicketSingleDtoMessageDto} from "./../API";
import {theme} from "..";

export interface ISupportMessageColorHelperResponse {
    backgroundColor: string;
    messageColor: string;
    originalMessageColor?: string;
    lightBackgroundColor: string;
}

export const SupportMessageColorHelper = (
    message?: SupportTicketSingleDtoMessageDto,
    messageType?: ReplyState,
): ISupportMessageColorHelperResponse => {
    let originalMessageColor;

    switch (messageType) {
        case "sql-query":
            originalMessageColor = theme.palette.themeLight;
            break;
        case "forward":
            originalMessageColor = SharedColors.gray10;
            break;
        case "new":
            originalMessageColor = SharedColors.yellow10;
            break;
        case "task":
            originalMessageColor = SharedColors.red10;
            break;
        case "internal-communication":
        case "note":
        case "edit-note":
        case "edit-task":
            originalMessageColor = SharedColors.yellow10;
            break;
        case "reply":
            originalMessageColor = SharedColors.gray10;
            break;
    }

    if (!originalMessageColor) {
        if (message?.isQueryExecution) {
            originalMessageColor = theme.palette.themeLight;
        } else if (message?.isTask) {
            if (message.isTaskDone) {
                originalMessageColor = SharedColors.yellowGreen10;
            } else {
                originalMessageColor = SharedColors.red10;
            }
        } else if (message?.private) {
            if (message.helpId) {
                originalMessageColor = theme.palette.themeLight;
            } else {
                originalMessageColor = SharedColors.yellow10;
            }
        } else if (message?.inbound) {
            originalMessageColor = CommunicationColors.tint10;
        } else if (!message?.inbound) {
            originalMessageColor = SharedColors.gray20;
        }
    }

    const messageColor = Color(originalMessageColor).toString();
    // const backgroundColor = Color(messageColor).alpha(0.05).toString();
    const backgroundColor = Color(messageColor).lightness(95).toString();
    const lightBackgroundColor = Color("#ffffffa0").toString();

    // return { backgroundColor, messageColor: Color(messageColor).alpha(0.15).toString(), originalMessageColor, lightBackgroundColor };
    return {
        backgroundColor,
        messageColor: Color(messageColor).lightness(95).toString(),
        originalMessageColor,
        lightBackgroundColor,
    };
};
